import { useEffect, useState } from "react";
import api from "@/lib/api";

/** The signed-in media buyer's ?mb= tracking code (null for everyone else). */
export function useTrackingCode(enabled) {
  const [code, setCode] = useState(null);
  useEffect(() => {
    if (!enabled) return;
    api.get("/media-buyer/tracking-code").then((r) => setCode(r.data.tracking_code)).catch(() => setCode(null));
  }, [enabled]);
  return code;
}

export const withCode = (url, code) => (code ? `${url}${url.includes("?") ? "&" : "?"}mb=${encodeURIComponent(code)}` : url);
